import React from 'react';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';

interface PageLayoutProps {
  children: React.ReactNode;
  maxWidth?: 'md' | 'lg' | 'xl' | 'full';
}

export default function PageLayout({ children, maxWidth = 'lg' }: PageLayoutProps) {
  const maxWidthClasses = {
    md: 'max-w-3xl',
    lg: 'max-w-4xl',
    xl: 'max-w-6xl',
    full: 'max-w-7xl'
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <PublicHeader />
      <main className="flex-1">
        <div className={`${maxWidthClasses[maxWidth]} mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12`}>
          {children}
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
